import { render, staticRenderFns } from "./ManagementRolesinDialog.vue?vue&type=template&id=540c5b73&scoped=true"
import script from "./ManagementRolesinDialog.vue?vue&type=script&lang=js"
export * from "./ManagementRolesinDialog.vue?vue&type=script&lang=js"
import style0 from "./ManagementRolesinDialog.vue?vue&type=style&index=0&id=540c5b73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540c5b73",
  null
  
)

export default component.exports